import { useState } from "react";
import { showError, showSuccess } from "utils/notifications";

const useSequentialImageUpload = (apiCall) => {
    const [uploading, setUploading] = useState(false);
    const [uploadedData, setUploadedData] = useState([]);

    const uploadImages = async ({
        files = [],
        fileFieldName = "file",
        payload = {},
        successMessage = "Files uploaded successfully",
    }) => {
        if (!Array.isArray(files) || files.length === 0) return [];

        setUploading(true);
        const results = [];

        try {
            for (const file of files) {
                const formData = new FormData();

                formData.append(fileFieldName, file);

                Object.keys(payload).forEach((key) => {
                    if (payload[key] !== undefined && payload[key] !== null) {
                        formData.append(key, payload[key]);
                    }
                });

                const response = await apiCall({ data: formData });

                if (!response?.data?.success) {
                    showError(response?.data?.error || "Upload failed");
                    break;
                }

                results.push(response.data.data);
            }

            if (results.length) {
                showSuccess(successMessage);
            }

            setUploadedData(results);
            return results;

        } catch (error) {
            console.error("Sequential upload error:", error);
            showError("Something went wrong during upload");
            return [];
        } finally {
            setUploading(false);
        }
    };

    return {
        uploading,
        uploadImages,
        uploadedData,
    };
};

export default useSequentialImageUpload;
